import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Tooltip } from 'react-tooltip';
import { useStore } from '../../hooks';
import { ITranscriptionResult } from '../../views/authorized/pages/telephony/types';
import { Icon, InfoIcon, Text, Wrapper } from './transcript-button.styled';
//TODO: было бы хорошо использовать всего одну иконку и просто перекрашивать её
// (но сейчас она красится внутри, а не снаружи, т.к. не стандартного для нас вида svg
import grayIcon from '../../assets/icons/transcribation_record.svg';
import blueIcon from '../../assets/icons/transcribation_record_blue.svg';
import redIcon from '../../assets/icons/transcribation_record_red.svg';
import { DotsLoader } from '../loaders';
import { TooltipInner } from '../tooltip';

interface Props {
  transcription: ITranscriptionResult | null;
  callId: string;
  handler: () => void;
}

export const TranscriptButton: FC<Props> = observer(
  ({ callId, handler, transcription }) => {
    const { common } = useStore();
    const fulfilled: boolean = !!transcription?.transcript?.length;
    const pending: boolean = common.callsInTranscribation.includes(callId);
    const error: boolean =
      transcription !== null && !transcription?.transcript?.length;

    const errorHandler = async (err: any) => {
      const error = await err.json();

      if (error.detail) {
        switch (error.detail) {
          case 'call processing in progress':
            common.setCallsInTranscribation(callId);
            break;
          case 'the call was already processed':
            common.setCallsInTranscribation(callId);
            //TODO: по-хорошему тут надо перезапрашивать звонок
            break;
          default:
            break;
        }
      }
    };

    const handleClick = () => {
      if (pending || error) {
        return;
      }

      if (fulfilled) {
        handler();
      } else {
        common.initTranscribation(callId).then(
          (res) => {
            common.setCallsInTranscribation(callId);
          },
          (err) => {
            errorHandler(err);
          }
        );
      }
    };

    return (
      <Wrapper>
        <Icon src={fulfilled ? blueIcon : error ? redIcon : grayIcon} />
        {pending ? (
          <DotsLoader />
        ) : (
          <Text
            isFulfilled={fulfilled}
            isError={error}
            onClick={() => handleClick()}
          >
            {error ? 'Ошибка' : 'Стенограмма'}
          </Text>
        )}
        {error && (
          <>
            <InfoIcon
              data-tooltip-variant="info"
              data-tooltip-id="transcript_error"
            />
            <Tooltip id="transcript_error">
              <TooltipInner>
                Не удалось обработать диалог из-за плохого качества записи
              </TooltipInner>
            </Tooltip>
          </>
        )}
      </Wrapper>
    );
  }
);
